import { SpecificationFormRule } from './specification-form-rule';

export class MinigridRule {
  public static rule(): SpecificationFormRule {
    return {
      fields: {
        postalCode: {
          display: false,
          required: false
        },
        address1: {
          display: false,
          required: false
        },
        address2: {
          display: false,
          required: false
        },
        name: {
          display: true,
          required: true,
          headingKey: 'project-name'
        },
        projectType: {
          display: true,
          required: true
        },
        description: {
          display: true,
          required: false
        },
        map: {
          display: true,
          required: false
        },
        country: {
          display: true,
          required: true
        },
        state: {
          display: true,
          required: true
        },
        city: {
          display: true,
          required: true
        },
        latitude: {
          display: true,
          required: true
        },
        longitude: {
          display: true,
          required: true
        },
        cod: {
          display: true,
          required: true,
          headingKey: 'cod'
        },
        tenderProject: {
          display: true,
          required: false
        },
        currency: {
          display: true,
          required: false,
          headingKey: 'tariff-currency'
        },
        exchangeRate: {
          display: true,
          required: false
        },
        program: {
          display: true,
          required: false
        },
        status: {
          display: true,
          required: false
        }
      },
      keys: {
        header: 'site-location',
        info: 'basic-info',
        location: 'project-location',
        currency: 'tariff'
      }
    };
  }
}
